import ObjectHelper from 'utils/ObjectHelper';
const commonConfig = {
  // 1. OBSS API client id and secret (used for AWS SIT)
  svcHost: ObjectHelper.isDspLogon()
    ? process.env.REACT_APP_API_HOST_DSP
    : process.env.REACT_APP_API_HOST,
  obssClientId: 'SINGAPORE',
  obssClientSecret: 'some client secret',
  breakpoint: 700,
  scores: {
    questionnaireId: 61,
    certIndicator: false,
    questionnaireType: 'ACCDT',
  },
  params: {
    action: 'A',
    response: {
      questionnaireId: 61,
      employeeNumber: '29000101',
      channelCode: 'OHI',
      // questionnaireStatus: 'ACCDTED',
      questionResponse: '',
    },
  },
  updateParams: {
    action: 'U',
    response: {
      questionnaireId: 61,
      responseId: 2521410,
      captureDateTime: '',
      expiryDateTime: '',
      totalScore: 0,
      questionResponse: '',
    },
  },
  specialParams: {
    accredited: {questionNumber: '93', answerNumber: 'B'},
    knowleageNum: {questionNumber: '96', answerNumber: 'B'},
    qualifiedObj: {questionNumber: '7', answerNumber: 'A', answerInputText: 'Experienced'},
    notQualifiedObj: {questionNumber: '7', answerNumber: 'B', answerInputText: 'Inexperienced'},
    expQuestionObj: {questionNumber: '96', answerNumber: 'A'},
    knowleageSumbit: {questionNumber: '98', answerNumber: 'A', answerInputText: null},
    knowleageDraft: {questionNumber: '98', answerNumber: 'B', answerInputText: 'EQT'},
    professionalNum: {questionNumber: '96', answerNumber: 'C'},
  },
  saas: {
    anonymousCommsTokenUrl: process.env.REACT_APP_SAAS_COMMS_TOKEN_HOST,
    saasIpUrl: process.env.REACT_APP_SAAS_IP_HOST,
    postSaaSlogonRedirectUrl: process.env.REACT_APP_SAAS_LOGON_REDIRECT_HOST,
    client_id: 'ee9040e831104176863fe594b0cc600b',
    client_secret: 'cfd8728597e24427BA44EA29EF93BCE0',
    Accept: '*/*',
    backurl:
      'https://www.env609.qualityassurance.ebanking.hsbc.com.hk/1/3/obadaptor?cmd_in=&uid=hsbc.myhsbc&source=tp',
  },
  dsp: {
    anonymousCommsTokenUrl: process.env.REACT_APP_DSP_COMMS_TOKEN_HOST,
    dspIpUrl: process.env.REACT_APP_DSP_IP_HOST,
    postDsplogonRedirectUrl: process.env.REACT_APP_DSP_LOGON_REDIRECT_HOST,
    groupMemberCode: 'HBAP',
    nextPage: 'SAAS30RESOURCE',
    targetCAMLevel: '30',
    functionName: 'IC2ICLAUNCH', // LOGIN/STEPUP/IC2ICLAUNCH
  },
  gsp: {
    bankUrl: process.env.REACT_APP_BANK_HOST,
  },
  errorCauses: [
    {code: 'SYS9999', message: 'The System Error'},
    {code: 'QAS0005', message: 'Missing locale'},
    {code: 'QAS0006', message: 'Missing customer'},
    {code: 'QAS0007', message: 'Missing questionnaire response key'},
    {code: 'QAS0008', message: 'Missing maintenance action'},
    {code: 'QAS0009', message: 'Invalid maintenance action'},
    {code: 'QAS0010', message: 'Missing questionnaire response maintenance record'},
    {code: 'QAS0011', message: ''},
    {code: 'QAS0012', message: ''},
    {code: 'QAS0013', message: ''},
    {code: 'QAS0014', message: 'Missing answer number'},
    {code: 'QAS0125', message: ''},
    {code: 'QAS0127', message: ''},
    {code: 'CUS0404', message: 'Customer not exists'},
    {code: 'QAS0103', message: ''},
  ],
  knowleageUrl: [
    'equities',
    'fixedIncome',
    'exchangeTradedFunds',
    'structuredProducts',
    'options',
    'managedFunds',
    'futures',
    'warrants',
  ],
  tealium: {
    toUseTealium: true,
    prodEnvDesc: '',
    marketSuffix: '-rbwm-gsp',
  },
  accreditedInvestorHomepage: process.env.REACT_APP_HOME_PAGE_HOST,
};
export default commonConfig;
